import { toast as sonnerToast } from "sonner";

/*
 * Toast stilovi, v2 redizajn ("editorial punk"):
 * ravna --bg-surface površina bez gradijenata, tanka ivica, levi akcenat
 * u statusnoj boji iz dizajn tokena (globalStyles.js).
 */
export const toastBaseStyle = {
  background: "var(--bg-surface)",
  border: "1px solid var(--border-strong)",
  borderRadius: "var(--radius-card)",
  color: "var(--text-primary)",
  fontFamily: "var(--font-body)",
  boxShadow: "0 12px 32px rgba(0, 0, 0, 0.45)",
};

const withAccent = (color) => ({
  ...toastBaseStyle,
  borderLeft: `3px solid ${color}`,
});

const styles = {
  neutral: toastBaseStyle,
  success: withAccent("var(--success)"),
  error: withAccent("var(--danger)"),
  info: withAccent("var(--brand)"),
  warning: withAccent("var(--brand)"),
};

export const toast = {
  success: (message, options) =>
    sonnerToast.success(message, { style: styles.success, ...options }),

  error: (message, options) =>
    sonnerToast.error(message, { style: styles.error, ...options }),

  info: (message, options) =>
    sonnerToast.info(message, { style: styles.info, ...options }),

  warning: (message, options) =>
    sonnerToast.warning(message, { style: styles.warning, ...options }),

  loading: (message, options) =>
    sonnerToast.loading(message, { style: styles.neutral, ...options }),

  custom: (message, options) =>
    sonnerToast(message, { style: styles.neutral, ...options }),

  promise: (promise, options) =>
    sonnerToast.promise(promise, {
      loading: { style: styles.neutral },
      success: { style: styles.success },
      error: { style: styles.error },
      ...options,
    }),

  dismiss: sonnerToast.dismiss,
  message: sonnerToast.message,
};
